import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { ToastService } from '../services/toast.service';
import { LanguageService } from '../services/language.service';

@Directive({
  selector: '[appEmailCharacterRestriction]'
})
export class EmailCharacterRestrictionDirective {

  // Define the allowed characters for an email address
  private allowedCharacters: RegExp = /^[a-zA-Z0-9@._-]*$/;
  @Input() maxLength!: number;

  //private maxLength: number = 50;
  // Regular expression to detect emojis
  private emojiRegex: RegExp = /[\u{1F600}-\u{1F64F}|\u{1F300}-\u{1F5FF}|\u{1F680}-\u{1F6FF}|\u{1F700}-\u{1F77F}|\u{1F780}-\u{1F7FF}|\u{1F800}-\u{1F8FF}|\u{1F900}-\u{1F9FF}|\u{1FA00}-\u{1FA6F}|\u{1FA70}-\u{1FAFF}|\u{2600}-\u{26FF}|\u{2700}-\u{27BF}|\u{2B50}-\u{2B55}|\u{23F0}-\u{23F3}|\u{2B06}-\u{2B07}|\u{2B05}-\u{2B07}]/u;
  activeLanguage: any;

  constructor(private el: ElementRef, private toasterService: ToastService,private langService: LanguageService,) {}

  // Listen for the 'input' event to allow only email-related characters and restrict emojis
  // @HostListener('input', ['$event']) onInput(event: Event) {
  //   const inputElement = this.el.nativeElement as HTMLInputElement;
  //   const value = inputElement.value;
  
  //   // Check if the value contains any invalid characters or emojis
  //   const sanitizedValue = value.replace(this.emojiRegex, '').replace(/[^a-zA-Z0-9@._-]/g, '');

  //   if (value !== sanitizedValue) {
  //     // Show an alert using the ToastService
  //     this.toasterService.show(`Special characters and emojis are not allowed!`, {
  //       class: 'danger',
  //       title: 'Alert',
  //     });

  //     // Update the input value by removing invalid characters and emojis
  //     inputElement.value = sanitizedValue;
  //   }
  // }
  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const char = event.key;
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const currentText = inputElement.value;
    if(this.maxLength === undefined || this.maxLength === null)
    {
      this.maxLength=50;
    }
    // Check if the input exceeds the max length
    if (currentText.length >= this.maxLength) {
      event.preventDefault();
      this.toasterService.show('Maximum character limit of '+this.maxLength+' reached.', {
        class: 'danger',
        title: 'Input Limit Reached'
      });
      return;
    }

    // Validate allowed characters and disallow emojis
    if (!this.allowedCharacters.test(char) || this.emojiRegex.test(char)) {
      event.preventDefault();
      this.listenToLanguageChanges();
      if(this.activeLanguage == 'mr'){
        this.toasterService.show(`अवैध वर्ण "${char}"! फक्त पूर्णविराम (.), स्वल्पविराम (,), हायफन (-), आणि अंडरस्कोर (_) विशेष वर्णांना अनुमती आहे. इमोजींना परवानगी नाही.`, {
          class: 'danger',
          title: 'Invalid Input'
        });
      }
      else{
        this.toasterService.show(`Invalid character "${char}"! Only period (.), comma (,), hyphen (-), and underscore (_) special characters are allowed. Emojis are not allowed.`, {
          class: 'danger',
          title: 'Invalid Input'
        });
      }
    }
  }
  private listenToLanguageChanges() {
    this.langService.language$.subscribe((language: any) => {
      this.activeLanguage = language;
    });
  }
}
